// import React, { useState, useEffect } from 'react';
// import { toast } from 'sonner';
// import { css } from '@emotion/react';
// import { ClipLoader } from 'react-spinners';
// import { Pie } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import { FaEye } from 'react-icons/fa'; // For the view icon
// import AdminActions from './AdminActions';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const override = css`
//   display: block;
//   margin: 0 auto;
// `;

// const ApplicationTable = () => {
//   const [applications, setApplications] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedImage, setSelectedImage] = useState(null); // State for enlarged image
//   const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

//   useEffect(() => {
//     const fetchApplications = async () => {
//       try {
//         const response = await fetch(`${apiUrl}application/allApplication`, {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${localStorage.getItem('token')}`,
//           },
//         });
//         const data = await response.json();
//         if (response.ok) {
//           setApplications(data);
//         } else {
//           toast.error(data.message || 'Failed to fetch applications');
//         }
//       } catch (error) {
//         console.error('Fetch Error:', error);
//         toast.error('An error occurred while fetching applications');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchApplications();
//   }, [apiUrl]);

//   const filteredApplications = applications.filter(app =>
//     `${app.companyId?.companyName || ''} ${app.applicant[0]?.firstName || ''} ${app.applicant[0]?.lastName || ''} ${app.position || ''}`.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   // Pie chart data for status distribution
//   const statusCounts = applications.reduce((acc, app) => {
//     acc[app.status] = (acc[app.status] || 0) + 1;
//     return acc;
//   }, {});
//   const pieData = {
//     labels: Object.keys(statusCounts),
//     datasets: [{
//       data: Object.values(statusCounts),
//       backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
//       hoverOffset: 4,
//     }],
//   };

//   // Handle image view
//   const handleViewImage = (imageUrl) => {
//     setSelectedImage(imageUrl);
//     // Open in new tab for larger view (alternative: modal can be implemented)
//     window.open(imageUrl, '_blank');
//   };

//   // Close image view (if using modal, uncomment and implement modal logic)
//   const handleCloseImage = () => {
//     setSelectedImage(null);
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-screen bg-gray-900">
//         <ClipLoader color="#f97316" css={override} size={50} />
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-900 min-h-screen text-white">
//       <h1 className="text-3xl font-bold mb-6 text-orange-500">Applications - {applications.length > 0 ? applications.length : 0}</h1>
//       <div className="mb-6">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search by employer, applicant, or position..."
//           className="p-3 border border-gray-700 rounded-md w-full md:w-1/3 bg-gray-700 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500"
//         />
//       </div>
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
//         <div className="lg:col-span-2 overflow-x-auto shadow-lg rounded-lg">
//           <table className="w-full bg-gray-800 border-collapse">
//             <thead>
//               <tr className="bg-gray-700">
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Employer Name</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Applicant Name</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Position</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Company Address</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Availability</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Resume</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Status</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Date Hired</th>
//                 <th className="border-b border-gray-600 p-4 text-left text-orange-400">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredApplications.map((app) => (
//                 <tr key={app._id} className="border-b border-gray-600 hover:bg-gray-700 transition-colors">
//                   <td className="border-r border-gray-600 p-4">{app.companyId?.companyName || 'Unknown Employer'}</td>
//                   <td className="border-r border-gray-600 p-4">{`${app.applicant[0]?.firstName || ''} ${app.applicant[0]?.lastName || ''}` || 'Unknown Applicant'}</td>
//                   <td className="border-r border-gray-600 p-4">{app.position}</td>
//                   <td className="border-r border-gray-600 p-4">{app.companyAddress}</td>
//                   <td className="border-r border-gray-600 p-4">{app.availability}</td>
//                   <td className="border-r border-gray-600 p-4 flex items-center">
//                     {app.resume && (
//                       <img
//                         src={app.resume}
//                         alt="Resume"
//                         className="w-16 h-16 object-cover mr-2"
//                       />
//                     )}
//                     {app.resume && (
//                       <FaEye
//                         className="text-orange-500 cursor-pointer hover:text-orange-300"
//                         onClick={() => handleViewImage(app.resume)}
//                       />
//                     )}
//                   </td>
//                   <td className="border-r border-gray-600 p-4">{app.status}</td>
//                   <td className="border-r border-gray-600 p-4">{app.dateHired || 'N/A'}</td>
//                   <td className="border-r border-gray-600 p-4">
//                     {localStorage.getItem('userType') === 'admin' && (
//                       <AdminActions applicationId={app._id} />
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//         <div className="lg:col-span-1 bg-gray-800 p-6 rounded-lg shadow-lg">
//           <h2 className="text-xl font-semibold text-orange-500 mb-4">Application Status Distribution</h2>
//           <Pie data={pieData} />
//         </div>
//       </div>

//       {/* Optional Modal for Image View (uncomment and implement if preferred) */}
//       {selectedImage && (
//         <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
//           <div className="relative">
//             <img src={selectedImage} alt="Enlarged Resume" className="max-w-full max-h-[80vh]" />
//             <button onClick={handleCloseImage} className="absolute top-2 right-2 text-white text-2xl">&times;</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ApplicationTable;



import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import { Pie, Bar } from 'react-chartjs-2';
import { 
  Chart as ChartJS, 
  ArcElement, 
  Tooltip, 
  Legend, 
  CategoryScale, 
  LinearScale, 
  BarElement 
} from 'chart.js';
import { FaEye, FaCalendarDay, FaCalendarWeek, FaCalendarAlt, FaCalendar, FaList } from 'react-icons/fa';
import AdminActions from './AdminActions';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const override = css`display: block; margin: 0 auto;`;

const ApplicationTable = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilter, setActiveFilter] = useState('All'); // 'All', 'Today', 'Week', 'Month', 'Year'
  const [selectedResume, setSelectedResume] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3008/api/v1/';

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await fetch(`${apiUrl}application/allApplication`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        });
        const data = await response.json();
        if (response.ok) {
          setApplications(data);
        } else {
          toast.error(data.message || 'Failed to fetch applications');
        }
      } catch (error) {
        console.error('Fetch Error:', error);
        toast.error('An error occurred while fetching applications');
      } finally {
        setLoading(false);
      }
    };
    fetchApplications();
  }, [apiUrl]);

  // Date calculations
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfWeek = new Date(now);
  startOfWeek.setDate(now.getDate() - now.getDay());
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const startOfYear = new Date(now.getFullYear(), 0, 1);

  // Filter applications based on activeFilter
  const getFilteredByTime = () => {
    switch (activeFilter) {
      case 'Today':
        return applications.filter(app => new Date(app.createdAt) >= startOfToday);
      case 'Week':
        return applications.filter(app => new Date(app.createdAt) >= startOfWeek);
      case 'Month':
        return applications.filter(app => new Date(app.createdAt) >= startOfMonth);
      case 'Year':
        return applications.filter(app => new Date(app.createdAt) >= startOfYear);
      case 'All':
      default:
        return applications;
    }
  };

  const timeFilteredApps = getFilteredByTime();

  // Search filter on top of time filter
  const filteredApplications = timeFilteredApps.filter(app =>
    `${app.companyId?.companyName || ''} ${app.applicant?.[0]?.firstName || ''} ${app.applicant?.[0]?.lastName || ''} ${app.position || ''}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  // Time stats (always show real counts)
  const todayApps = applications.filter(app => new Date(app.createdAt) >= startOfToday);
  const weekApps = applications.filter(app => new Date(app.createdAt) >= startOfWeek);
  const monthApps = applications.filter(app => new Date(app.createdAt) >= startOfMonth);
  const yearApps = applications.filter(app => new Date(app.createdAt) >= startOfYear);

  // Status Pie Chart Data
  const statusCounts = applications.reduce((acc, app) => {
    acc[app.status] = (acc[app.status] || 0) + 1;
    return acc;
  }, {});

  const pieData = {
    labels: Object.keys(statusCounts),
    datasets: [{
      data: Object.values(statusCounts),
      backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#FF5733'],
      hoverOffset: 8,
      borderWidth: 3,
      borderColor: '#111827',
    }],
  };

  // Bar Chart Data for time periods
  const barData = {
    labels: ['Today', 'This Week', 'This Month', 'This Year'],
    datasets: [{
      label: 'Applications',
      data: [todayApps.length, weekApps.length, monthApps.length, yearApps.length],
      backgroundColor: '#f97316',
      borderColor: '#fb923c',
      borderWidth: 2,
      borderRadius: 8,
      hoverBackgroundColor: '#fb923c',
    }],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      y: { beginAtZero: true, grid: { color: '#374151' }, ticks: { color: '#9CA3AF' } },
      x: { grid: { color: '#374151' }, ticks: { color: '#9CA3AF' } },
    },
  };

  const handleViewResume = (resumeUrl) => setSelectedResume(resumeUrl);

  const filterButtons = [
    { label: 'All', value: 'All', icon: FaList, count: applications.length },
    { label: 'Today', value: 'Today', icon: FaCalendarDay, count: todayApps.length },
    { label: 'This Week', value: 'Week', icon: FaCalendarWeek, count: weekApps.length },
    { label: 'This Month', value: 'Month', icon: FaCalendarAlt, count: monthApps.length },
    { label: 'This Year', value: 'Year', icon: FaCalendar, count: yearApps.length },
  ];

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-950">
        <ClipLoader color="#f97316" css={override} size={60} />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 bg-gray-950 min-h-screen text-white">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8">
        <h1 className="text-4xl font-bold text-orange-500 tracking-tight">
          Applications <span className="text-gray-400 text-2xl">({applications.length})</span>
        </h1>
      </div>

      {/* Time Filter Buttons */}
      <div className="mb-8">
        <p className="text-gray-400 text-sm mb-3">Filter Applications</p>
        <div className="flex flex-wrap gap-3">
          {filterButtons.map((btn) => {
            const Icon = btn.icon;
            const isActive = activeFilter === btn.value;
            return (
              <button
                key={btn.value}
                onClick={() => setActiveFilter(btn.value)}
                className={`flex items-center gap-3 px-6 py-3 rounded-2xl font-medium transition-all duration-200 border
                  ${isActive 
                    ? 'bg-orange-600 text-white border-orange-600 shadow-lg shadow-orange-600/30' 
                    : 'bg-gray-900 border-gray-700 hover:border-orange-500 hover:text-orange-400'}`}
              >
                <Icon className={`text-xl ${isActive ? 'text-white' : 'text-gray-400'}`} />
                <span>{btn.label}</span>
                <span className={`ml-1 px-2.5 py-0.5 text-xs rounded-full 
                  ${isActive ? 'bg-white/20' : 'bg-gray-800'}`}>
                  {btn.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Search Bar */}
      <div className="mb-8">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by employer, applicant name, or position..."
          className="w-full md:w-96 p-4 bg-gray-900 border border-gray-700 rounded-2xl text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-500/30 transition-all"
        />
      </div>

      {/* Stats Cards + Charts */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 mb-10">
        {/* Time Trend Bar Chart */}
        <div className="xl:col-span-7 bg-gray-900 border border-gray-800 rounded-3xl p-6">
          <h2 className="text-2xl font-semibold mb-6 text-orange-400">Application Trends</h2>
          <div className="h-80">
            <Bar data={barData} options={chartOptions} />
          </div>
        </div>

        {/* Status Pie Chart */}
        <div className="xl:col-span-5 bg-gray-900 border border-gray-800 rounded-3xl p-6">
          <h2 className="text-2xl font-semibold mb-6 text-orange-400">Status Distribution</h2>
          <div className="h-80 flex items-center justify-center">
            <Pie data={pieData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>
      </div>

      {/* Applications Table */}
      <div className="bg-gray-900 border border-gray-800 rounded-3xl overflow-hidden">
        <div className="p-6 border-b border-gray-800 flex items-center justify-between">
          <h2 className="text-xl font-semibold">
            {activeFilter === 'All' ? 'All Applications' : `${activeFilter} Applications`}
            <span className="text-orange-500 ml-2">({filteredApplications.length})</span>
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[1100px]">
            <thead>
              <tr className="bg-gray-950 border-b border-gray-700">
                <th className="p-6 text-left text-orange-400 font-medium">Employer</th>
                <th className="p-6 text-left text-orange-400 font-medium">Applicant</th>
                <th className="p-6 text-left text-orange-400 font-medium">Position</th>
                <th className="p-6 text-left text-orange-400 font-medium hidden md:table-cell">Address</th>
                <th className="p-6 text-left text-orange-400 font-medium">Availability</th>
                <th className="p-6 text-left text-orange-400 font-medium">Resume</th>
                <th className="p-6 text-left text-orange-400 font-medium">Status</th>
                <th className="p-6 text-left text-orange-400 font-medium hidden lg:table-cell">Date Hired</th>
              
              </tr>
            </thead>
            <tbody>
              {filteredApplications.length > 0 ? (
                filteredApplications.map((app) => (
                  <tr key={app._id} className="border-b border-gray-800 hover:bg-gray-800/70 transition-all duration-200">
                    <td className="p-6 font-medium">{app.companyId?.companyName || 'Unknown'}</td>
                    <td className="p-6">
                      {`${app.applicant?.[0]?.firstName || ''} ${app.applicant?.[0]?.lastName || ''}`.trim() || 'Unknown Applicant'}
                    </td>
                    <td className="p-6">{app.position}</td>
                    <td className="p-6 hidden md:table-cell text-gray-400 text-sm max-w-xs truncate">
                      {app.companyAddress}
                    </td>
                    <td className="p-6 text-sm">{app.availability}</td>
                    <td className="p-6">
                      {app.resume && (
                        <div className="flex items-center gap-3">
                          <img
                            src={app.resume}
                            alt="Resume"
                            className="w-12 h-12 object-cover rounded-xl border border-gray-700"
                          />
                          <button
                            onClick={() => handleViewResume(app.resume)}
                            className="flex items-center gap-1.5 text-orange-500 hover:text-orange-400 transition"
                          >
                            <FaEye /> View
                          </button>
                        </div>
                      )}
                    </td>
                    <td className="p-6">
                      <span className={`px-4 py-1.5 rounded-full text-xs font-semibold
                        ${app.status === 'Accepted' ? 'bg-emerald-500/20 text-emerald-400' :
                          app.status === 'Rejected' ? 'bg-red-500/20 text-red-400' :
                          app.status === 'Offer' ? 'bg-blue-500/20 text-blue-400' :
                          'bg-gray-700 text-gray-300'}`}>
                        {app.status}
                      </span>
                    </td>
                    <td className="p-6 hidden lg:table-cell text-gray-400">
                      {app.dateHired || '—'}
                    </td>
                    <td className="p-6">
                      {localStorage.getItem('userType') === 'admin' && (
                        <AdminActions applicationId={app._id} />
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="p-16 text-center text-gray-500">
                    No applications found for the selected filter.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Resume Modal */}
      {selectedResume && (
        <div className="fixed inset-0 bg-black/95 z-[100] flex items-center justify-center p-4">
          <div className="relative max-w-5xl w-full bg-gray-900 rounded-3xl overflow-hidden shadow-2xl">
            <button
              onClick={() => setSelectedResume(null)}
              className="absolute top-6 right-6 z-10 bg-gray-800 hover:bg-red-600 w-12 h-12 rounded-2xl flex items-center justify-center text-3xl transition-colors"
            >
              ×
            </button>
            <img
              src={selectedResume}
              alt="Resume Preview"
              className="w-full max-h-[90vh] object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicationTable;